import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import HomeService from "../../../Services/HomeService";
import Swal from "sweetalert2";
import toast from "react-hot-toast";

const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "#868e96",
  margin: "15px",
  fontWeight: "bold",
};

function ManageJobCategory() {
  const [allData, setAllData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editID, setEditID] = useState("");
  const [isEdit, setIsEdit] = useState(false);

  const initialValue = {
    catName: "",
    description: "",
  };

  const [editData, setEditData] = useState(initialValue);

  const columns = [
    { name: "S.No.", selector: (row) => row.sln, sortable: true },
    { name: "Category", selector: (row) => row.catName, wrap: true },
    { name: "Description", selector: (row) => row.description, wrap: true },
    {
      name: "Status",
      cell: (row) => (
        <button
          className={`btn btn-${row.status ? "success" : "danger"}`}
          onClick={() => toggleStatus(row.id, row.status)}
        >
          {row.status ? "Active" : "Inactive"}
        </button>
      ),
    },
    {
      name: "Action",
      cell: (row) => (
        <>
          <span title="Edit" onClick={() => handleEdit(row)}>
            <i
              className="fa-solid fa-pen-to-square"
              style={{
                cursor: "pointer",
                padding: "5px",
                marginRight: "5px",
                fontSize: "1.5em",
                color: "rgb(133, 218, 79)",
                backgroundColor: "#E9F3F7",
              }}
            ></i>
          </span>
          <span
            title="Delete"
            onClick={() => {
              handleDelete(row.id);
              // console.log("id", row);
            }}
          >
            <i
              className="fa-solid fa-trash-can text-danger"
              style={{
                cursor: "pointer",
                padding: "5px",
                marginRight: "5px",
                fontSize: "1.5em",
                color: "#477DA5",
                backgroundColor: "#E9F3F7",
              }}
            ></i>
          </span>
        </>
      ),
    },
  ];

  const toggleStatus = async (id, currentStatus) => {
    try {
      const newStatus = !currentStatus;
      await HomeService.updateJobCategoryStatus(id, { status: newStatus });
      toast.success("Status updated!");
      fetchAllData();
    } catch (error) {
      toast.error("Failed to update status.");
      console.error("Error updating status:", error);
    }
  };

  const fetchAllData = async () => {
    setLoading(true);
    try {
      const res = await HomeService.getJobCategory();
      console.log("job category", res.data);
      if (res.status) {
        const arr = res?.data?.map((ele, ind) => ({
          sln: ind + 1,
          id: ele._id,
          catName: ele.catName,
          description: ele.description,
          status: ele.status,
        }));
        setAllData(arr);
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      console.error("Error fetching allData:", error);
      toast.error("Failed to load allData!");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllData();
  }, []);

  const handleEdit = (row) => {
    setIsEdit(true);
    setEditData({ catName: row?.catName, description: row?.description });
    setEditID(row.id);
  };

  const handleDelete = async (id) => {
    console.log("delete ID", id);
    const result = await Swal.fire({
      title: `Delete Job Category`,
      text: "Are you sure you want to delete this designation?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "#d33",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    });
    if (result.isConfirmed) {
      try {
        const res = await HomeService.deleteJobCategory(id);
        if (res?.status) {
          Swal.fire("Deleted!", "Category has been deleted.", "success");
          fetchAllData();
        }
      } catch (error) {
        Swal.fire("Error!", "Failed to delete Category.", "error");
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      console.log("EFD153", editData);
      // return

      if (isEdit) {
        const res = await HomeService.updateJobCategory(editID, editData);
        if (res?.status) {
          toast.success("Category updated successfully!");
          setIsEdit(false);
          setEditData(initialValue);
          fetchAllData();
        } else {
          toast.error(res?.message);
        }
      }
    } catch (error) {
      toast.error("Failed to save Category.");
      console.error("Error saving Category:", error);
    }
  };

  return (
    <>
      <div className="main_wrap" style={{ marginTop: "6rem" }}>
        <div className="container-fluid">
          {isEdit ? (
            <section className="chartBox_area">
              <h2>Edit Job Category</h2>
              <hr />
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-12 mt-3">
                    <label htmlFor="name">
                      Category Name<span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      id="catName"
                      className="form-control"
                      value={editData.catName}
                      onChange={(e) =>
                        setEditData({ ...editData, catName: e.target.value })
                      }
                      placeholder="Enter Designation"
                      required
                    />
                  </div>
                  <div className="col-md-12 mt-3">
                    <label>Description</label>

                    <textarea
                      className="form-control"
                      name="description"
                      value={editData.description}
                      onChange={(e) =>
                        setEditData({
                          ...editData,
                          description: e.target.value,
                        })
                      }
                      placeholder="Enter description (if any)"
                    ></textarea>
                  </div>
                </div>
                <button
                  style={{
                    background: "rgb(133, 218, 79)",
                    borderRadius: "13px",
                  }}
                  type="submit"
                  className="btn mt-3"
                >
                  Submit
                </button>
                <button
                  type="button"
                  className="btn btn-secondary mt-3"
                  style={{ marginLeft: "11px" }}
                  onClick={() => setIsEdit(false)}
                >
                  Cancel
                </button>
              </form>
            </section>
          ) : (
            <>
              <div className="mt-5">
                <div style={headLineStyle} className="page-headline">
                  Manage Job Category
                </div>
                {loading ? (
                  <p>Loading...</p>
                ) : (
                  <DataTable
                    columns={columns}
                    data={allData}
                    pagination
                    responsive
                    highlightOnHover
                  />
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default ManageJobCategory;
